/* 布局 */
//前台
import Layout from "@views/layout";

const goodsspectplRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "goodsspectpl/list",
        name: "GOODSSPECTPL",
        meta: {
            title: "商品规格模板",
            keepAlive:true
        },
        component: () => import("@views/business/goodsspectpl/index.vue"),
    },
        ],
};

export default goodsspectplRouter;
